var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49984 16.5C3.49984 16.9167 3.83317 17.3333 4.33317 17.3333H7.6665C8.1665 17.3333 8.49984 16.9167 8.49984 16.5V15.6667H3.49984V16.5ZM5.99984 0.666672C2.74984 0.666672 0.166504 3.25001 0.166504 6.50001C0.166504 8.50001 1.1665 10.25 2.6665 11.25V13.1667C2.6665 13.5833 2.99984 14 3.49984 14H8.49984C8.99984 14 9.33317 13.5833 9.33317 13.1667V11.25C10.8332 10.1667 11.8332 8.41667 11.8332 6.50001C11.8332 3.25001 9.24984 0.666672 5.99984 0.666672Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49984 16.5C3.49984 16.9167 3.83317 17.3333 4.33317 17.3333H7.6665C8.1665 17.3333 8.49984 16.9167 8.49984 16.5V15.6667H3.49984V16.5ZM5.99984 0.666672C2.74984 0.666672 0.166504 3.25001 0.166504 6.50001C0.166504 8.50001 1.1665 10.25 2.6665 11.25V13.1667C2.6665 13.5833 2.99984 14 3.49984 14H8.49984C8.99984 14 9.33317 13.5833 9.33317 13.1667V11.25C10.8332 10.1667 11.8332 8.41667 11.8332 6.50001C11.8332 3.25001 9.24984 0.666672 5.99984 0.666672Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCategory1);
export default __webpack_public_path__ + "static/media/iconCategory1.e4ccccf0414033a1e4f7ebc067b045f8.svg";
export { ForwardRef as ReactComponent };